import React from 'react';

import { IIconRotatableProps } from 'assets/icons/IconProps';

export const DoubleChevronRight = ({
  width = 24,
  height = 24,
  rotate = 0,
  stroke = '#82878c',
  strokeWidth = 2,
}: IIconRotatableProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      transform={`rotate(${rotate} 12 12)`}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 17l5-5-5-5M6 17l5-5-5-5"
    />
  </svg>
);
